import { Filters, FiltersLayout, List, ListHeader, ListPageLayout, SearchInput } from 'framework/list';
import { CreateButton } from 'framework/ui/ui-builder';
import { ACTIVE_STATUS, CREATE_BUDGET, useBudgetService } from 'domain/shared/budget';
import { useBudgetUrl } from 'domain/shared/budget';
import BudgetListLayout from './BudgetListLayout';
import BudgetStatusFilter from 'domain/finance/budget/shared/filter/BudgetStatusFilter';

const BudgetList = () => {
  const { searchRootBudgets } = useBudgetService();
  const { getCreateUrl } = useBudgetUrl();

  const filters = (
    <Filters>
      <FiltersLayout>
        <BudgetStatusFilter source="status" label="Status" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <List
      getDataMethod={searchRootBudgets}
      defaultSortOrder="ASC"
      defaultSortField="createdAt"
      defaultFilter={{
        status: { in: [ACTIVE_STATUS] },
      }}
    >
      <ListPageLayout
        header={<ListHeader label="Budgets" icon="fa-coins" />}
        actions={[
          <CreateButton
            url={getCreateUrl()}
            label="Create Budget"
            key="create-budget"
            permissionToCheck={CREATE_BUDGET}
          />,
        ]}
        filter={filters}
        search={<SearchInput label="budget name" />}
      >
        <BudgetListLayout />
      </ListPageLayout>
    </List>
  );
};

export default BudgetList;
